import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { episodes } from "@/mocks/episodes";

const PAGE_SIZE = 6;

export default function LatestEpisodes() {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const sorted = useMemo(() => [...episodes].sort((a, b) => b.number - a.number), []);
  const shown = sorted.slice(0, visible);
  const hasMore = visible < sorted.length;

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <SectionHeading
        eyebrow="最新更新"
        title="最近上线剧集"
        desc="按上线时间倒序排列，点击任意一集即可进入播放页观看。"
        action={
          <Link
            to="/updates"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap w-fit"
          >
            查看全部更新 <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {shown.map((ep) => (
          <Link
            key={ep.id}
            to={`/play/${ep.number}`}
            className="group flex gap-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors p-2.5 md:p-3 cursor-pointer"
          >
            <div className="relative w-32 md:w-36 shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
              <img
                src={ep.thumbnail}
                alt={`善良的小姨子 第${ep.number}集 ${ep.title}`}
                title={`善良的小姨子 第${ep.number}集`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute bottom-1 right-1 px-1.5 py-0.5 rounded bg-foreground-950/80 text-background-50 text-[10px]">
                {ep.duration}
              </span>
            </div>
            <div className="min-w-0 flex-1 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="shrink-0 px-1.5 py-0.5 rounded bg-primary-50 text-primary-700 text-[11px] font-medium">
                  第{ep.number}集
                </span>
                <span className="text-[11px] text-foreground-400">{ep.releaseDate}</span>
              </div>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mt-1.5 truncate group-hover:text-primary-600 transition-colors">
                {ep.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">{ep.summary}</p>
              <span className="mt-auto pt-2 text-[11px] text-foreground-400 flex items-center gap-1">
                <i className="ri-eye-line"></i> {ep.views} 次播放
              </span>
            </div>
          </Link>
        ))}
      </div>

      {hasMore && (
        <div className="flex justify-center mt-8">
          <button
            type="button"
            onClick={() => setVisible((v) => Math.min(v + PAGE_SIZE, sorted.length))}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:bg-background-200 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-add-line"></i>
            加载更多剧集
          </button>
        </div>
      )}
    </section>
  );
}